import React from 'react';
import { MerchantSettingsProvider } from '@features/merchant-settings';
import { MerchantSettingsDialog } from '@widgets/merchant-settings';
import { LayoutWrapper } from './layout-wrapper';

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps): React.ReactElement {
  return (
    <MerchantSettingsProvider>
      <LayoutWrapper>
        {children}
      </LayoutWrapper>
      <MerchantSettingsDialog />
    </MerchantSettingsProvider>
  );
}
